











































































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import { ANOMALIE_TYPES } from "../models/Materiel";
import { DateUtils } from "../utils/DateUtils";

export default {
    name: "MouvementCard",
    props: {
        mouvement: Object,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
        };
    },
    computed: {
        sourceLabel(): string {
            return this.mouvement.type === "out" ? "SORTIE" : "RETOUR";
        },
        sourceIcon(): string {
            return this.mouvement.type === "out" ? "↑" : "↓";
        },
        sourceSub(): string {
            let destination = this.mouvement.destination_str;
            if (this.mouvement.type === "out") {
                return destination ? "→ " + destination : "Nouveau chantier";
            }
            return destination ? "← " + destination : "Retour au dépôt";
        },
        anomalieTypesSuffix(): string {
            let labels = this.mouvement.anomalie_types_labels;
            return labels.length ? " : " + labels.join(", ") : "";
        },
        preexistanteDateStr(): string {
            let preexistante = this.mouvement.anomalie_preexistante;
            return preexistante
                ? DateUtils.sqlToDateStr(preexistante.date_mouvement)
                : "";
        },
        preexistanteTypesLabels(): Array<string> {
            let preexistante = this.mouvement.anomalie_preexistante;
            if (!preexistante || !preexistante.anomalie_types) {
                return [];
            }
            return _.map(preexistante.anomalie_types, function (code) {
                return ANOMALIE_TYPES[code] || code;
            });
        },
    },
    methods: {
        truncate(text: string, max: number): string {
            if (!text) {
                return "";
            }
            return text.length > max ? text.substring(0, max) + "…" : text;
        },
        openRapport(): void {
            this.MaterielApi.openInNewTab(
                this.MaterielApi.rapportPdfUrl(this.mouvement.id)
            );
        },
    },
};
